var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretdoubleleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.816 5.066a.8.8 0 00-1.132-1.132l-7.5 7.5a.8.8 0 000 1.132l7.5 7.5a.8.8 0 001.132-1.132L4.88 12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.316 5.066a.8.8 0 00-1.132-1.132l-7.5 7.5a.8.8 0 000 1.132l7.5 7.5a.8.8 0 001.132-1.132L12.38 12z"
  }))));
}

export default SvgCaretdoubleleft;